import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "nr-table-container" }
const _hoisted_2 = ["data-field"]
const _hoisted_3 = {
  key: 0,
  class: "nr-table-sort-header"
}
const _hoisted_4 = {
  key: 1,
  class: "nr-table-empty"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = {
  key: 2,
  class: "nr-table-loading"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "nr-table-overlay" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrIcon = _resolveComponent("NrIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.rows.length)
      ? (_openBlock(), _createElementBlock("table", {
          key: 0,
          class: _normalizeClass(["nr-table", { striped: $props.striped }]),
          ref: "table"
        }, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.parsedColumns, (column, index) => {
                return _renderSlot(_ctx.$slots, "column", _normalizeProps(_guardReactiveProps(column)), () => [
                  (_openBlock(), _createElementBlock("th", {
                    class: _normalizeClass({
                  sticky: column.sticky,
                  'is-sortable': column.sortable
                }),
                    key: `header-column-${index}`,
                    "data-field": column.field
                  }, [
                    (column.sortable)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createTextVNode(_toDisplayString(column.label) + " ", 1),
                          _createVNode(_component_NrIconButton, {
                            size: "small",
                            variant: "minimal-neutral",
                            "aria-label": `sort by ${column.label}`,
                            icon: { name: $options.sortIcon(column.field) },
                            onClick: ($event: any) => ($options.handleTableSort(column.field))
                          }, null, 8, ["aria-label", "icon", "onClick"])
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(column.label), 1)
                        ], 64))
                  ], 10, _hoisted_2))
                ])
              }), 256))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.parsedRows, (row, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: `data-row-${index}`
              }, [
                _renderSlot(_ctx.$slots, "row", { row: row }, () => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.parsedColumns, (column) => {
                    return _renderSlot(_ctx.$slots, column.field, {
                      row: row,
                      value: row[column.field],
                      field: column.field,
                      column: $options.getColumnDataByField(column.field),
                      dataKey: `data-row-${index}-col-${column.field}`,
                      sticky: $options.getColumnDataByField(column.field).sticky
                    }, () => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent($options.getColumnDataByField(column.field).sticky ? 'th' : 'td'), {
                        key: `data-row-${index}-col-${column.field}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row[column.field]), 1)
                        ]),
                        _: 2
                      }, 1024))
                    ])
                  }), 256))
                ])
              ]))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true),
    (!$props.rows.length && !$props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          ($props.emptyText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString($props.emptyText), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, "No " + _toDisplayString($props.tableName) + " found.", 1),
                _createElementVNode("p", null, " Try adjusting your filters to find the " + _toDisplayString($props.tableName) + " you are looking for. ", 1)
              ]))
        ]))
      : _createCommentVNode("", true),
    ($props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_NrIcon, {
            class: "nr-table-spinner",
            name: "spinner"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}